require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-kleinmuerbisch.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-kleinmuerbisch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-kleinmuerbisch!./.cache/json/betreuungseinrichtungen-guessing-kleinmuerbisch.json
// module id = 893
// module chunks = 231608221292675